import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import localePT from '@angular/common/locales/pt';
import localeExtraPT from '@angular/common/locales/extra/pt';

import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { RatingModule } from 'primeng/rating';
import { InputTextModule } from 'primeng/inputtext';
import { ToolbarModule } from 'primeng/toolbar';
import { FileUploadModule } from 'primeng/fileupload';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import {DividerModule} from 'primeng/divider';
import {TabViewModule} from 'primeng/tabview';
import {TimelineModule} from 'primeng/timeline';
import {ScrollPanelModule} from 'primeng/scrollpanel';
import {ListboxModule} from 'primeng/listbox';
import {GMapModule} from 'primeng/gmap';
import {SelectButtonModule} from 'primeng/selectbutton';
import { DropdownModule } from 'primeng/dropdown';
import {CheckboxModule} from 'primeng/checkbox';
import { ConfirmationService } from 'primeng/api';

import { GrupoDescontoComponent } from './grupo-desconto/grupo-desconto.component';
import { DescontoComponent } from './desconto/desconto.component';
import { DescontoService } from './desconto.service';

registerLocaleData(localePT, 'pt', localeExtraPT);
@NgModule({
  declarations: [GrupoDescontoComponent, DescontoComponent],
  providers:[DescontoService, ConfirmationService],
  imports: [
    TooltipModule,
    CommonModule,
    FormsModule,
    TableModule,
    ButtonModule,
    RatingModule,
    InputTextModule,
    ToolbarModule,
    FileUploadModule,
    DialogModule,
    RouterModule,
    ConfirmDialogModule,
    RadioButtonModule,
    InputTextModule,
    InputNumberModule,    
    BrowserModule,
    DividerModule,
    TabViewModule,
    TimelineModule,
    ScrollPanelModule,
    ListboxModule,
    GMapModule,
    SelectButtonModule,
    DropdownModule,
    CheckboxModule
  ]
})
export class DescontoModule { }
